import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Analytics from './components/Analytics';
import WaveBand from './components/WaveBand';
import Home from './pages/Home';
import About from './pages/About';
import Festival from './pages/Festival';
import Gallery from './pages/Gallery';
import Sponsors from './pages/Sponsors';
import Donate from './pages/Donate';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import NotFound from './pages/NotFound';
import './App.css';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Analytics />
      <div className="App d-flex flex-column min-vh-100">
        <Navigation />
        <main className="site-main flex-grow-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/festival" element={<Festival />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/sponsors" element={<Sponsors />} />
            <Route path="/donate" element={<Donate />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <WaveBand />
        <Footer />
      </div>
    </Router>
  );
}

export default App;
